import { Fragment, useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';

import { useForm } from '../../../shared/hooks/Form';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';

import { InvoiceService as Service } from '../InvoiceService';
import { TaxCodeService } from '../../bao-cao/trang-thai-mst/TaxCodeService';
import { PetrolimexService } from '../../danh-muc/hang-hoa-xang-dau/PetrolimexService';

import { ToastService } from '../../../AppToast';
import { AmountToWord } from '../../../service/AmountToWord';
import { FormatDisplay } from '../../../shared/format';
import { TenantCompanyService } from '../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../../service/UserStorage';
import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';
import { TenantClientService } from '../../danh-muc/khach-hang/TenantClientService';
import { MGateWayService } from '../../lich-su-truyen-nhan/MGateWayService';
import { ConfirmDialogService } from '../../../AppConfirmDialog';

export const DialogCrupXangDau = (props: any) => {

  const { display, setDisplay, view, currencies, paymentTypes, registerInvoice, selectedItems, refreshLazyData, onSubmitEnd } = props;

  const [submitting, setSubmitting] = useState(false);
  const [tenantCompany, setTenantCompany] = useState(null);
  const [useBuyer, setUseBuyer] = useState(false);
  const [customers, setCustomers] = useState({});
  const [products, setProducts] = useState([]);
  const [coins, setCoins] = useState([]);
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [fractionDigits, setFractionDigits] = useState({});

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      setTenantCompany(data);
    });
    PetrolimexService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setProducts(items.map(item => {
        return {
          ...item,
          nameDisplay: `${item.code} - ${item.name}`
        };
      }));
    });

  }, []);

  useEffect(() => {
    if (registerInvoice?.id && currencies?.length) {
      RegisterInvoiceService.getInvoiceSettings(registerInvoice.id).then(data => {
        const _defaultValue = {}, _fractionDigits = {};
        const currency = currencies.find(it => it.code === 'VND');
        data.forEach(item => {

          switch (item.fieldName) {
            case 'nonTaxZone':
              _defaultValue[item.fieldName] = item.defaultValue;
              break;
          }
          _fractionDigits[item.fieldName] = 0;
          if (currency && item.typeFormat && currency[item.typeFormat] > 0) {
            _fractionDigits[item.fieldName] = currency[item.typeFormat];
          }
        });


        setDefaultValue(_defaultValue);
        setFractionDigits(_fractionDigits);
      });
    }
  }, [registerInvoice?.id, currencies]);

  useEffect(() => {
    // console.log(fractionDigits?.['unitPrice'])

    if (display) {

      formInfo.reset();
      formBuyer.reset();
      formProduct.reset();
      setSelectedCoin(null);
      setUseBuyer(false);

      switch (display) {
        case 'create':
          let invoiceDate = new Date();
          if (selectedItems?.invoiceDate) {
            invoiceDate = new Date(selectedItems.invoiceDate);
          }
          formInfo.setValue({
            invoiceSerial: registerInvoice?.symbolCode || '',
            invoiceDate,
            paymentMethod: 'TM/CK',
            fieldName5: selectedItems?.storeName || '',
            fieldName8: selectedItems?.deviceCode || '',
            uniqueKeyConnection: selectedItems?.keyApi || '',
          });
          if (selectedItems?.useBuyer) {
            setUseBuyer(true);
          }
          if (selectedItems?.buyerTaxCode) {
            formBuyer.setValue({
              buyerTaxCode: selectedItems?.buyerTaxCode || '',
              buyerCode: selectedItems?.buyerCode || '',
              buyerLegalName: selectedItems?.buyerLegalName || '',
              buyerAddress: selectedItems?.buyerAddress || '',
              buyerTel: selectedItems?.buyerTel || '',
              buyerEmail: selectedItems?.buyerEmail || ''
            });
          } else {
            formBuyer.setValue({
              buyerDisplayName: 'Bán cho người tiêu dùng',
              buyerTaxCode: selectedItems?.buyerTaxCode || '',
              buyerTel: selectedItems?.buyerTel || '',
              buyerEmail: selectedItems?.buyerEmail || ''
            });
          }
          if (selectedItems?.productCode) {
            const product = products.find(it => it.code === selectedItems.productCode);
            if (product) {
              let unitPrice = 0;
              if (selectedItems.unitPriceDisplay > 0) {
                if (registerInvoice?.symbolCode && registerInvoice?.symbolCode[0] === '1' && product?.ratioTax >= 0) {
                  unitPrice = selectedItems.unitPriceDisplay / (1 + (product?.ratioTax / 100));
                } else {
                  unitPrice = selectedItems.unitPriceDisplay;
                }
              }

              let vatCode = '', vatName = '', ratioTax = '';
              if (registerInvoice?.symbolCode && registerInvoice?.symbolCode[0] === '1' && product?.taxName) {
                vatCode = product?.vatCode;
                vatName = product?.taxName;
                ratioTax = product?.ratioTax;
              }

              let totalAmountWithoutVAT = null, vatAmount = null;
              if (selectedItems.totalAmount > 0 && registerInvoice?.symbolCode && registerInvoice?.symbolCode[0] === '1' && product?.ratioTax >= 0) {
                totalAmountWithoutVAT = formatNumber((selectedItems.totalAmount / (1 + (product.ratioTax / 100))), fractionDigits['totalAmountWithoutVAT']);
                vatAmount = formatNumber((selectedItems.totalAmount - totalAmountWithoutVAT), fractionDigits['vatAmount']);
              }

              let totalAmountToWord = '';
              if (selectedItems.totalAmount > 0) {
                totalAmountToWord = AmountToWord.DocTienBangChu(`${selectedItems.totalAmount}`, 'VND', {
                  readCurrency: true,
                  readDecimal: false
                });
              }

              formProduct.setValue({
                product,
                productCode: selectedItems.productCode,
                productName: selectedItems.productName,
                unitCode: selectedItems.unitCode || product.unit,
                totalAmount: selectedItems.totalAmount || 0,
                quantity: selectedItems.quantity || 0,
                unitPriceDisplay: selectedItems.unitPriceDisplay || 0,
                unitPrice,
                totalAmountWithoutVAT,
                vatAmount,
                vatCode,
                vatName,
                ratioTax,
                totalAmountToWord,
              });
            }
          }
          break;
        case 'clone':
        case 'update':
          if (selectedItems) {
            Service.getDetail(selectedItems.id).then(detail => {

              if (display === 'clone') {
                detail.invoiceDate = new Date();
                detail.invoiceNumber = '';
                detail.uniqueKeyConnection = null;
                Object.assign(detail, Service.DEFAULT_PAYMENT_FIELDS);
              }
              if (detail.buyerLegalName) {
                setUseBuyer(true);
              }

              formInfo.setValue(detail);
              formBuyer.setValue(detail);
              if (detail?.invoiceDetail?.length) {
                const invoiceRow = detail.invoiceDetail[0];

                if (invoiceRow.unitPrice > 0) {
                  if (detail.invoiceSerial && detail.invoiceSerial[0] === '1' && invoiceRow.vatRate >= 0) {
                    invoiceRow.unitPriceDisplay = Math.round(invoiceRow.unitPrice * (1 + (invoiceRow.vatRate / 100)));
                  } else {
                    invoiceRow.unitPriceDisplay = Math.round(invoiceRow.unitPrice);
                  }
                }

                formProduct.setValue({
                  product: products.find(it => it.code === invoiceRow.productCode),
                  productCode: invoiceRow.productCode,
                  productName: invoiceRow.productName,
                  unitCode: invoiceRow.unitCode,
                  totalAmount: invoiceRow.totalAmount,
                  quantity: invoiceRow.quantity,
                  unitPrice: invoiceRow.unitPrice,
                  unitPriceDisplay: invoiceRow.unitPriceDisplay,
                  totalAmountWithoutVAT: detail.totalAmountWithoutVAT,
                  vatCode: invoiceRow.vatCode,
                  vatName: invoiceRow.vatName,
                  ratioTax: invoiceRow.vatRate,
                  vatAmount: invoiceRow.vatAmount,
                  totalAmountToWord: detail.totalAmountToWord,
                });
              }
            });
          }
          break;
      }
    }
  }, [display, fractionDigits]); // eslint-disable-line react-hooks/exhaustive-deps

  const formInfo = useForm({
    fields: [
      { field: 'uniqueKeyConnection', type: 'hidden' },
      { field: 'invoiceSerial', header: 'Ký hiệu', disabled: true, className: 'md:col-6', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { field: 'invoiceNumber', header: 'Số hóa đơn', disabled: true, className: 'md:col-6', labelClassName: 'md:col-fixed w-11rem justify-content-center', inputClassName: 'md:col' },
      { field: 'invoiceDate', header: 'Ngày lập', required: true, type: 'Calendar', className: 'md:col-12', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { field: 'paymentMethod', header: 'HT thanh toán', required: true, type: 'Dropdown', DropdownProps: { options: paymentTypes }, className: 'md:col-12', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { field: 'fieldName5', header: 'Tên cửa hàng', InputTextProps: { maxLength: 250 }, className: 'md:col-12', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { field: 'fieldName8', header: 'Mã vòi bơm', InputTextProps: { maxLength: 250 }, className: 'md:col-12', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' }
    ],
    layout: 'Horizontal'
  });

  const searchTaxCodeTenant = () => {
    const _value = getValue();
    if (_value?.taxCode) {
      TaxCodeService.get(_value?.taxCode).then(data => {
        if (data.ten_cty) {
          setValue({
            code: _value.code || '',
            taxCode: data.ma_so_thue || '',
            name: data.ten_cty || '',
            address: data.dia_chi || ''
          });
        } else {
          ToastService.error('Không tìm thấy dữ liệu');
        }
      });
    }
  }

  const { render: renderDialogTenantClient, getValue, setValue, create: createTenantClient } = useDialogCrup({
    header: 'Khách hàng',
    dataKey: 'id',
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã khách hàng', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'taxCode', header: 'Mã số thuế', InputTextProps: { maxLength: 14, validator: 'taxCode' }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={searchTaxCodeTenant} />
          </div>
        )
      },
      { field: 'name', header: 'Tên đơn vị', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'personContact', header: 'Người mua hàng', InputTextProps: { maxLength: 100 }, className: 'md:col-4' },
      { field: 'buyerIdentityCard', header: 'CCCD', InputTextProps: { maxLength: 100 }, className: 'md:col-4' },
      { field: 'buyerBudgetUnitCode', header: 'Mã đơn vị quan hệ ngân sách', InputTextProps: { maxLength: 100 }, className: 'md:col-4' },
      { field: 'address', header: 'Địa chỉ', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email', type: 'email', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'mobile', header: 'Điện thoại', InputTextProps: { maxLength: 20 }, className: 'md:col-6' },
      { field: 'bankAccount', header: 'Số tài khoản', InputTextProps: { maxLength: 30 }, className: 'md:col-5' },
      { field: 'bankName', header: 'Tên ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-7' }
    ],
    createItem: (item) => {
      return TenantClientService.create(item);
    },
    refreshLazyData: (data) => {
      if (data?.code) {
        formBuyer.setTouched(true);
        formBuyer.setValue({
          buyerCode: data
        });
      }
    }
  });

  const searchTaxCode = () => {
    const { buyerTaxCode } = formBuyer.getValue();
    if (buyerTaxCode) {
      // Gọi searchTaxCode (V1) trước
      MGateWayService.searchTaxCode(buyerTaxCode).then(data => {
        const provinceName = data.dctstinh ?
          (data.dctstinhten.includes('TP') ? data.dctstinhten.replace('TP', 'Thành phố') : `Tỉnh ${data.dctstinhten}`) : '';
        if (data?.mst) {
          formBuyer.setValue({
            buyerTaxCode: data.mst || '',
            buyerLegalName: data.tennnt || '',
            personContact: data.buyerDisplayName || '',
            buyerAddress: `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam` || ''
          });
        } else {
          // Nếu V1 không có dữ liệu, thử V2
          MGateWayService.searchTaxCodeV2(buyerTaxCode).then(v2Data => {
            if (v2Data?.buyerTaxCode) {
              formBuyer.setValue({
                buyerTaxCode: v2Data.buyerTaxCode || '',
                buyerLegalName: v2Data.buyerLegalName || '',
                buyerAddress: v2Data.buyerAddress || ''
              });
            }
          }).catch(v2Error => {
            ToastService.error('Lỗi khi tìm kiếm MST (V2).');
          });
        }
      }).catch(v1Error => {
        // Nếu V1 lỗi, thử V2
        MGateWayService.searchTaxCodeV2(buyerTaxCode).then(v2Data => {
          if (v2Data?.buyerTaxCode) {
            formBuyer.setValue({
              buyerTaxCode: v2Data.buyerTaxCode || '',
              buyerLegalName: v2Data.buyerLegalName || '',
              buyerAddress: v2Data.buyerAddress || ''
            });
          }
        }).catch(v2Error => {
          ToastService.error('Lỗi khi tìm kiếm MST.');
        });
      });
      // TaxCodeService.get(buyerTaxCode).then(data => {
      //   if (data.ten_cty) {
      //     formBuyer.setValue({
      //       buyerTaxCode: data.ma_so_thue || '',
      //       buyerLegalName: data.ten_cty || '',
      //       buyerAddress: data.dia_chi || ''
      //     });
      //   } else {
      //     ToastService.error('Không tìm thấy dữ liệu');
      //   }
      // });
    }
  }

  const itemTemplate = (by, setWidth) => (item) => {
    const labels = [];
    if (item[by]) {
      labels.push(item[by]);
    }
    if (item.name) {
      labels.push(item.name);
    }
    if (item.address) {
      labels.push(item.address);
    }
    if (setWidth) {
      if (setWidth.startsWith && setWidth.startsWith('offsetWidth+')) {
        try {
          setWidth = document.getElementById(setWidth.replace('offsetWidth+', '')).offsetWidth;
        } catch (e) {
          setWidth = '50rem';
        }
      }
      return <div style={{ width: setWidth, whiteSpace: 'break-spaces' }}>{labels.join(' - ')}</div>
    }
    return labels.join(' - ');
  }

  const searchCustomers = by => event => {
    if (by === 'taxCode') {
      if (event.query?.trim()) {
        if (!/^[0-9-]+$/.test(event.query.trim()) || event.query.length > 14) {
          return ToastService.error('Mã số thuế không hợp lệ');
        }
      }
    }
    TenantClientService.getList({ [by]: event.query, MaxResultCount: 1000 }).then(({ items }) => {
      setCustomers(prevState => {
        prevState[by] = items;
        return { ...prevState };
      });
    });
  }

  const formBuyer = useForm({
    fields: [
      { field: 'buyerTaxCode', header: 'Mã số thuế', disabled: !useBuyer, type: 'AutoComplete', AutoCompleteProps: { suggestions: customers['taxCode'], completeMethod: searchCustomers('taxCode'), field: 'taxCode', itemTemplate: itemTemplate('taxCode', '50rem') }, className: 'md:col-4', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      {
        type: 'custom', className: 'md:col-fixed w-4rem', body: (
          <span className="p-inputgroup-addon" style={{ width: '25px', height: '27px' }}>
            <i className="pi pi-search" onClick={searchTaxCode} />
          </span>
        )
      },
      { field: 'buyerCode', header: 'Mã KH', disabled: !useBuyer, type: 'AutoComplete', AutoCompleteProps: { suggestions: customers['code'], completeMethod: searchCustomers('code'), field: 'code', itemTemplate: itemTemplate('code', '50rem') }, className: 'md:col', labelClassName: 'md:col-fixed w-8rem justify-content-center', inputClassName: 'md:col' },
      {
        type: 'custom', className: 'md:col-fixed w-3rem', body: (
          <span className="p-inputgroup-addon" style={{ width: '25px', height: '27px' }}>
            <i className="pi pi-plus" onClick={() => useBuyer && createTenantClient()} />
          </span>
        )
      },
      { field: 'fieldName9', header: 'Biển số xe', InputTextProps: { maxLength: 20 }, className: 'md:col-4', labelClassName: 'md:col-fixed w-9rem justify-content-center', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-fixed w-3rem' },
      { type: 'custom', className: 'md:col-12 p-0 m-0' },
      { field: 'buyerLegalName', header: 'Tên đơn vị', disabled: !useBuyer, type: 'AutoComplete', AutoCompleteProps: { suggestions: customers['name'], completeMethod: searchCustomers('name'), field: 'name', itemTemplate: itemTemplate('taxCode', 'offsetWidth+buyerLegalName') }, className: 'md:col', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      {
        type: 'custom', className: 'md:col-fixed w-3rem', body: (
          <span className="p-inputgroup-addon" style={{ width: '25px', height: '27px' }}>
            <i className="pi pi-search" onClick={searchTaxCode} />
          </span>
        )
      },
      { type: 'custom', className: 'md:col-12 p-0 m-0' },
      { field: 'buyerDisplayName', header: 'Tên người mua', InputTextProps: { maxLength: 100 }, className: 'md:col-4', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-fixed w-4rem' },
      { field: 'buyerTel', header: 'Số điện thoại', InputTextProps: { maxLength: 20 }, className: 'md:col', labelClassName: 'md:col-fixed w-8rem justify-content-center', inputClassName: 'md:col' },
      { field: 'buyerEmail', header: 'Email', InputTextProps: { maxLength: 300 }, className: 'md:col-4', labelClassName: 'md:col-fixed w-9rem justify-content-center', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-fixed w-3rem' },
      { type: 'custom', className: 'md:col-12 p-0 m-0' },
      { field: 'buyerAddress', header: 'Địa chỉ', disabled: !useBuyer, InputTextProps: { maxLength: 400 }, className: 'md:col', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-12 p-0 m-0' },
      { field: 'buyerIdentityCard', header: 'Căn cước công dân', InputTextProps: { maxLength: 12 }, className: 'md:col-4', labelClassName: 'md:col-fixed w-11rem', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-fixed w-4rem' },
      { field: 'buyerBudgetUnitCode', header: 'Mã đơn vị quan hệ ngân sách', InputTextProps: { maxLength: 7 }, className: 'md:col', labelClassName: 'md:col-fixed w-16rem justify-content-center', inputClassName: 'md:col' },
      { field: 'passportNumber', header: 'Số hộ chiếu', InputTextProps: { maxLength: 20 }, className: 'md:col-4', labelClassName: 'md:col-fixed w-9rem justify-content-center', inputClassName: 'md:col' },


    ],
    layout: 'Horizontal'
  });

  const onUseBuyerChange = value => {
    const { buyerDisplayName } = formBuyer.getValue();
    if (value) {
      if (buyerDisplayName === 'Bán cho người tiêu dùng') {
        formBuyer.setValue({
          buyerDisplayName: ''
        });
      }
    } else {
      formBuyer.setValue({
        buyerDisplayName: 'Bán cho người tiêu dùng'
      });
    }
    setUseBuyer(value);
  }

  const { buyerTaxCode, buyerCode, buyerLegalName } = formBuyer.getValue();

  useEffect(() => {
    if (formBuyer.touched) {
      const _value = formBuyer.getValue();
      let tenantClient: any;
      switch (_value.inputChange) {
        case 'buyerTaxCode':
          tenantClient = _value.buyerTaxCode;
          break;
        case 'buyerCode':
          tenantClient = _value.buyerCode;
          break;
        case 'buyerLegalName':
          tenantClient = _value.buyerLegalName;
          break;
      }

      if (tenantClient?.id) {
        _value.buyerTaxCode = tenantClient.taxCode || '';
        _value.buyerLegalName = tenantClient.name || '';
        _value.buyerAddress = tenantClient.address || '';
        _value.buyerDisplayName = tenantClient.personContact || '';
        _value.buyerTel = tenantClient.mobile || '';
        _value.buyerEmail = tenantClient.email || '';
        _value.buyerCode = tenantClient.code || '';
        _value.buyerBudgetUnitCode = tenantClient.buyerBudgetUnitCode || '';
        _value.buyerIdentityCard = tenantClient.buyerIdentityCard || '';
        formBuyer.setValue(_value);
      }
    }
  }, [buyerTaxCode, buyerCode, buyerLegalName]);

  const onCoinClick = coin => {
    formProduct.setTouched(true);
    setSelectedCoin(coin);
    const _value = formProduct.getValue();
    _value.totalAmount = coin;
    formProduct.setValue(_value);
  }

  const buttonPrices = <div className="grid" style={{ position: 'absolute' }}>
    {coins.map((coin, index) => <div key={index} className="col-3 flex justify-content-center">
      <div className="w-15rem">
        <Button label={FormatDisplay.number(coin)} onClick={() => onCoinClick(coin)} className={`${selectedCoin === coin ? '' : 'p-button-outlined'}`} />
      </div>
    </div>)}
  </div>

  const formProduct = useForm({
    fields: [
      { field: 'isAutoCalc', type: 'hidden' },
      { field: 'unitPrice', type: 'hidden' },
      { field: 'productCode', type: 'hidden' },
      { field: 'productName', type: 'hidden' },
      { field: 'unitCode', type: 'hidden' },
      { field: 'vatName', type: 'hidden' },
      { field: 'ratioTax', type: 'hidden' },
      { field: 'product', header: 'Chọn loại hàng', required: true, type: 'Dropdown', DropdownProps: { options: products, optionLabel: 'nameDisplay', filter: true, resetFilterOnHide: true }, className: 'md:col-6', labelClassName: 'md:col-fixed w-12rem', inputClassName: 'md:col' },
      { field: 'totalAmount', header: 'Tổng tiền thanh toán', required: true, type: 'InputNumber', InputNumberProps: { min: 0, minFractionDigits: fractionDigits['totalAmount'], maxFractionDigits: fractionDigits['totalAmount'] }, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-6 mb-0' },
      { field: 'quantity', header: 'Số lít', type: 'InputNumber', InputNumberProps: { min: 0, minFractionDigits: fractionDigits['quantity'], maxFractionDigits: fractionDigits['quantity'] }, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { type: 'custom', body: buttonPrices, className: 'md:col-6 mb-0 p-relative' },
      { field: 'unitPriceDisplay', header: 'Đơn giá (Bao gồm VAT)', disabled: true, type: 'InputNumber', InputNumberProps: { min: 0 }, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-6' },
      { field: 'totalAmountWithoutVAT', header: 'Tổng tiền trước thuế', disabled: true, type: 'InputNumber', InputNumberProps: { min: 0, minFractionDigits: fractionDigits['totalAmountWithoutVAT'], maxFractionDigits: fractionDigits['totalAmountWithoutVAT'] }, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-6' },
      { field: 'vatCode', header: 'Thuế suất', disabled: true, InputTextProps: { className: 'text-right' } as any, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { type: 'custom', className: 'md:col-6' },
      { field: 'vatAmount', header: 'Tổng tiền thuế', disabled: true, type: 'InputNumber', InputNumberProps: { min: 0, minFractionDigits: fractionDigits['vatAmount'], maxFractionDigits: fractionDigits['vatAmount'] }, className: 'md:col-6', labelClassName: 'md:col-fixed w-16rem pl-3', inputClassName: 'md:col' },
      { field: 'totalAmountToWord', header: 'Tổng tiền bằng chữ', required: true, InputTextProps: { maxLength: 255 }, className: 'md:col-12', labelClassName: 'md:col-fixed w-12rem', inputClassName: 'md:col' }
    ],
    layout: 'Horizontal', formClassName: 'detail'
  });

  const { invoiceSerial } = formInfo.getValue();
  const { product, totalAmount, quantity, unitPrice } = formProduct.getValue();

  useEffect(() => {
    const _coins = [];
    if (product?.list_price?.length) {
      _coins.push(...product.list_price);
    }
    setCoins(_coins);
    setSelectedCoin(null);
    if (formProduct.touched && product) {
      const _value = formProduct.getValue();
      _value.unitPrice = 0;
      if (product.price > 0) {
        _value.unitPrice = product.price;
      }
      if (product.code) {
        _value.productCode = product.code;
      }
      if (product.name) {
        _value.productName = product.name;
      }
      if (product.unit) {
        _value.unitCode = product.unit;
      }
      _value.vatCode = '';
      _value.vatName = '';
      _value.ratioTax = '';
      if (invoiceSerial && invoiceSerial[0] === '1' && product?.taxName) {
        _value.vatCode = product?.vatCode;
        _value.vatName = product?.taxName;
        _value.ratioTax = product?.ratioTax;
      }
      formProduct.setValue(_value);
    }
  }, [product]);

  useEffect(() => {
    if (formProduct.touched) {
      const _value = formProduct.getValue();

      if (_value.isAutoCalc) {
        delete _value.isAutoCalc;
        formProduct.setValue(_value);
        return;
      }

      switch (_value.inputChange) {
        case 'quantity':
          // TÍNH TOÁN DỰA TRÊN SỐ LÍT
          _value.unitPriceDisplay = null;
          _value.totalAmount = null;
          _value.totalAmountToWord = '';
          _value.totalAmountWithoutVAT = null;
          _value.vatAmount = null;

          if (_value.unitPrice > 0) {
            if (invoiceSerial && invoiceSerial[0] === '1' && _value.ratioTax >= 0) {
              _value.unitPriceDisplay = Math.round(_value.unitPrice * (1 + (_value.ratioTax / 100)));
            } else {
              _value.unitPriceDisplay = Math.round(_value.unitPrice);
            }
            _value.isAutoCalc = true;
            _value.totalAmount = formatNumber((_value.unitPriceDisplay * quantity), fractionDigits['totalAmount']);
            _value.totalAmountToWord = AmountToWord.DocTienBangChu(`${_value.totalAmount}`, 'VND', {
              readCurrency: true,
              readDecimal: false
            });
            if (_value.totalAmount !== selectedCoin) {
              setSelectedCoin(null);
            }

            if (_value.totalAmount > 0) {
              if (invoiceSerial && invoiceSerial[0] === '1' && _value?.ratioTax >= 0) {
                _value.totalAmountWithoutVAT = formatNumber((_value.totalAmount / (1 + (_value.ratioTax / 100))), fractionDigits['totalAmountWithoutVAT']);
                _value.vatAmount = formatNumber((_value.totalAmount - _value.totalAmountWithoutVAT), fractionDigits['vatAmount']);
              }
            }
          }
          break;
        default:
          // TÍNH TOÁN DỰA TRÊN TỔNG TIỀN THANH TOÁN
          _value.totalAmountToWord = '';
          if (typeof totalAmount === 'number') {
            _value.totalAmountToWord = AmountToWord.DocTienBangChu(`${totalAmount}`, 'VND', {
              readCurrency: true,
              readDecimal: false
            });
            if (totalAmount !== selectedCoin) {
              setSelectedCoin(null);
            }
          }

          _value.unitPriceDisplay = null;
          _value.quantity = null;
          _value.totalAmountWithoutVAT = null;
          _value.vatAmount = null;

          if (_value.unitPrice > 0) {
            if (invoiceSerial && invoiceSerial[0] === '1' && _value?.ratioTax >= 0) {
              _value.unitPriceDisplay = Math.round(_value.unitPrice * (1 + (_value.ratioTax / 100)));
            } else {
              _value.unitPriceDisplay = Math.round(_value.unitPrice);
            }
            if (totalAmount > 0) {
              _value.isAutoCalc = true;
              _value.quantity = formatNumber((totalAmount / _value.unitPriceDisplay), fractionDigits['quantity']);
            }
          }
          if (totalAmount > 0) {
            if (invoiceSerial && invoiceSerial[0] === '1' && _value?.ratioTax >= 0) {
              _value.totalAmountWithoutVAT = formatNumber((totalAmount / (1 + (_value.ratioTax / 100))), fractionDigits['totalAmountWithoutVAT']);
              _value.vatAmount = formatNumber((totalAmount - _value.totalAmountWithoutVAT), fractionDigits['vatAmount']);
            }
          }
      }
      delete _value.inputChange;
      formProduct.setValue(_value);
    }
  }, [invoiceSerial, totalAmount, quantity, unitPrice]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatNumber = (number: any, fraction?: number) => {
    if (typeof number === 'number') {
      if (!Number.isFinite(number) || Number.isNaN(number)) {
        number = 0;
      }
      if (`${number}`.length > 2 && `${number}`.split('.').length) {
        number = 1 * number.toPrecision(`${number}`.split('.')[0].length + fraction || 7);
      }
    }
    return number;
  }
  const submit = type => {
    if (!submitting) {
      if (formInfo.valid() && formBuyer.valid() && formProduct.valid()) {
        const _value: any = {
          ...defaultValue,
          registerInvoiceId: registerInvoice.id,
          currencyCode: 'VND',
          currencyId: currencies.find(it => it.code === 'VND').id,
          exchangeRate: '1',
          sellerTaxCode: tenantCompany.taxCode,
          sellerLegalName: tenantCompany.name,
          sellerAddress: tenantCompany.address,
          sellerEmail: tenantCompany.email || '',
          sellerTel: tenantCompany.tel || '',
          sellBankAccount: tenantCompany.bankAccount || '',
          sellerBankName: tenantCompany.bankName || '',
          sellerFax: tenantCompany.fax || '',
          sellerWebsite: tenantCompany.webSite || '',
          ...formInfo.getValue(), ...formBuyer.getValue(), ...formProduct.getValue(),
          keyApi: selectedItems?.keyApi
        };
        _value.invoiceDate = FormatDisplay.date(_value.invoiceDate, 'YYYY-MM-DD');

        const invoiceDetail: any = {
          ordinalNumber: '1',
          property: 1,
          orders: 1,
          productCode: _value.productCode,
          productName: _value.productName,
          unitCode: _value.unitCode,
          unitPrice: _value.unitPrice,
          vatCode: _value.vatCode,
          vatName: _value.taxName,
          vatRate: _value.ratioTax,
          totalAmount: _value.totalAmount,
          quantity: _value.quantity,
          vatAmount: _value.vatAmount,
          amountWithoutVAT: _value.totalAmountWithoutVAT,
          amount: _value.totalAmountWithoutVAT
        };
        if (invoiceSerial && invoiceSerial[0] === '2') {
          delete invoiceDetail.vatCode;
          delete invoiceDetail.vatName;
          delete invoiceDetail.vatRate;
          invoiceDetail.amountWithoutVAT = _value.totalAmount;
          invoiceDetail.amount = _value.totalAmount;
        }
        _value.amount = invoiceDetail.amount;

        _value.invoiceDetail = [invoiceDetail];
        _value.productId = _value.product.id;

        if (useBuyer) {
          if (_value.buyerTaxCode && !_value.buyerLegalName) {
            return ToastService.error('Tên đơn vị không được để trống.');
          }
          if (_value.buyerLegalName && !_value.buyerAddress) {
            return ToastService.error('Địa chỉ không được để trống.');
          }
        }

        // Tổng tiền thanh toán - tổng tiền trước thuế - tổng tiền thuế > 100
        // Thì báo lỗi
        if (_value.invoiceSerial.charAt(0) === "1") {
          if (_value.totalAmount >= 0 && _value.totalAmountWithoutVAT >= 0 && _value.vatAmount >= 0) {
            if (Math.abs(_value.totalAmount - _value.totalAmountWithoutVAT - _value.vatAmount) > 100) {
              return ToastService.error('Tổng tiền thanh toán không khớp với Tổng tiền trước thuế + Tiền thuế');
            }
          }
        }
        // ABS (Số lượng X Đơn giá bao gồm VAT - Tổng tiền thanh toán ) > 500 thì báo lỗi
        if (invoiceDetail.quantity > 0 && _value.unitPriceDisplay && invoiceDetail.totalAmount > 0) {
          if (Math.abs(invoiceDetail.quantity * _value.unitPriceDisplay - invoiceDetail.totalAmount) > 500) {
            return ToastService.error('Tổng tiền thanh toán không khớp so với Số lượng x Đơn giá bao gồm VAT.');
          }
        }

        setSubmitting(true);

        let method;
        switch (display) {
          case 'create':
          case 'clone':
            Object.assign(_value, Service.DEFAULT_PAYMENT_FIELDS);
            method = Service.create(_value);
            break;
          case 'update':
            _value.id = selectedItems.id;
            method = Service.update(selectedItems.id, _value);
            break;
        }
        method.then(result => {
          onSubmitEnd && onSubmitEnd(result, ['print', 'continue', 'sign'].includes(type));
          refreshLazyData();
          switch (type) {
            case 'print':
              setDisplay(null);
              view(result || selectedItems);
              break;
            case 'continue':
              formInfo.reset();
              formBuyer.reset();
              formProduct.reset();

              setUseBuyer(false);
              formInfo.setValue({
                invoiceSerial: registerInvoice?.symbolCode || '',
                invoiceDate: new Date(),
                paymentMethod: 'TM/CK'
              });
              formBuyer.setValue({
                buyerDisplayName: 'Bán cho người tiêu dùng'
              });
              break;
            case 'sign':
              ConfirmDialogService.confirmSign(() => {
                props.sign({
                  "CommandName": "SignInvoices",
                  "InvoiceIdArray": [(result.id || selectedItems.id)]
                });
              });
              ToastService.success();
              setDisplay(null);
              break;
            default:
              setDisplay(null);
          }
        }).catch(err => {
          onSubmitEnd && onSubmitEnd(err);
        }).finally(() => setSubmitting(false));
      }
    }
  }

  const footer = (
    <div className="flex justify-content-center gap-4">
      <Button label="Đóng" onClick={() => setDisplay(null)} className="p-button-outlined p-button-secondary p-button-sm" />
      <Button label="Lưu" onClick={() => submit('none')} loading={submitting} className="p-button-outlined p-button-sm" />
      <Button label="Lưu và Xem in" onClick={() => submit('print')} loading={submitting} className="p-button-outlined p-button-sm" />
      <Button label="Lưu và Ký" onClick={() => submit('sign')} loading={submitting} className="p-button-outlined p-button-sm" />
      {['create', 'clone'].includes(display) && <Button label="Lưu và Tạo tiếp" onClick={() => submit('continue')} loading={submitting} className="p-button-outlined p-button-sm" />}
    </div>
  );

  return (
    <Fragment>
      <Dialog header={`Hóa đơn xăng dầu`} footer={footer} visible={!!display} maximized={true} onHide={() => setDisplay(null)}
        className="form-xs bg-theme crup-invoice">
        <div className="grid mt-2">
          <div className="col-4 p-1 hd-xang-dau">
            <Fieldset legend="Thông tin chung" className="h-full">
              {formInfo.render()}
            </Fieldset>
          </div>
          <div className="col-8 p-1 hd-xang-dau">
            <Fieldset legend="Thông tin khách hàng">

              <div className="field-checkbox">
                <Checkbox inputId="useBuyer" checked={useBuyer} onChange={e => onUseBuyerChange(e.checked)} />
                <label htmlFor="useBuyer">Xuất cho doanh nghiệp</label>
              </div>

              {formBuyer.render()}
            </Fieldset>
          </div>
          <div className="col-12 p-1 hd-xang-dau">
            <Fieldset legend="Thông tin hàng hóa">
              {formProduct.render()}
            </Fieldset>
          </div>
        </div>
      </Dialog>
      {renderDialogTenantClient()}
    </Fragment>
  );
}
